import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { categories, shop } from "../../data";

export default function Categories() {
  return (
    <section
      id="categorie"
      data-testid="categories-section"
      className="py-24 md:py-32 bg-[#FBEFF3] scroll-mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <div className="text-xs tracking-[0.2em] uppercase text-[#C24E77] mb-6">
            Le nostre collezioni
          </div>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#123D5B] leading-tight">
            Tutto ciò che serve
            <span className="italic text-[#C24E77]"> per il buon riposo.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 auto-rows-fr">
          {categories.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className={`${c.span} ${c.tall ? "md:row-span-2" : ""}`}
            >
              <Link
                to={`/categoria/${c.slug}`}
                data-testid={`category-link-${c.slug}`}
                className={`group relative block rounded-2xl overflow-hidden border border-black/5 ${
                  c.tall ? "min-h-[420px] h-full" : "min-h-[300px] h-full"
                }`}
              >
                <img
                  src={c.img}
                  alt={c.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#123D5B]/85 via-[#123D5B]/25 to-transparent" />
                <div className="relative h-full flex flex-col justify-end p-7">
                  <ArrowUpRight
                    className="absolute top-6 right-6 text-white/80 opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300"
                    size={24}
                    aria-hidden="true"
                  />
                  <h3 className="font-serif text-3xl text-white">{c.title}</h3>
                  <p className="text-sm text-white/85 mt-2 max-w-sm leading-relaxed">
                    {c.desc}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-xs tracking-[0.15em] uppercase text-[#F2A0B4]">
                    Vedi prodotti
                    <ArrowUpRight size={14} aria-hidden="true" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="text-[#4A5863] mb-5">
            Vuoi sapere se abbiamo quello che cerchi? Chiamaci, ti rispondiamo
            volentieri.
          </p>
          <a
            href={shop.phoneHref}
            data-testid="categories-call-button"
            className="inline-flex items-center gap-2 bg-[#123D5B] hover:bg-[#0C2A40] text-white rounded-sm px-8 py-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(18,61,91,0.28)]"
          >
            Chiama il {shop.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
